import { createContext, useContext, useEffect, useState } from "react";
import { api, formatError, setStoredToken, getStoredToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!getStoredToken()) { setUser(false); setLoading(false); return; }
    api.get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => { setStoredToken(null); setUser(false); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    try {
      const { data } = await api.post("/auth/login", { username, password });
      if (data.token) setStoredToken(data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) { return { ok: false, error: formatError(e) }; }
  };

  const register = async (payload) => {
    try {
      const { data } = await api.post("/auth/register", payload);
      if (data.token) setStoredToken(data.token);
      setUser(data.user);
      return { ok: true, welcome_email_sent: data.welcome_email_sent };
    } catch (e) { return { ok: false, error: formatError(e) }; }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setStoredToken(null);
    setUser(false);
  };

  const refreshMe = async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); } catch (e) {}
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshMe, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
